import React, { useContext, useState, useEffect } from "react";
import Header from "../components/Header.js";
import Sidebar from "../components/Sidebar.js";
import "../styles/Dashboard.css";
import { UserContext } from "../pages/UserContext.js";
import { apiFetch } from "../api.js";
const Dashboard = () => {
  const { user } = useContext(UserContext);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [menuData, setMenuData] = useState([]);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  /*useEffect(() => {
    fetch("http://144.143.142.29:5000/api/menus")
      .then((res) => res.json())
      .then((data) => setMenuData(data))
      .catch((err) => console.error(err));
  }, []);*/
  useEffect(() => {
    const schema = localStorage.getItem("schema"); // ✅ get stored schema

    apiFetch("/api/menus")
      .then((res) => res.json())
      .then((data) => setMenuData(data))
      .catch((err) => console.error(err));
  }, []);

  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  return (
    <div className="dashboard-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="dashboard-body">
        {isSidebarOpen && <Sidebar menuData={menuData} />}

        <main className="dashboard-content">
          {/* ================= BRANCH ================= */}
          <div className="top-row top-row-left">
            <select className="branch-select">
              <option>JODHPUR, BASNI WORKS</option>
            </select>
          </div>

          {/* ================= FILTERS ================= */}
          <div className="top-row">
            <div className="section-filter">
              <input type="date" />
              <input type="date" />
              <div className="icon-group">
                <span>⟳</span>
                <span>📊</span>
                <span>📈</span>
                <span>🗄</span>
              </div>
            </div>

            <div className="section-filter">
              <input type="date" />
              <input type="date" />
              <div className="icon-group">
                <span>⟳</span>
                <span>📊</span>
                <span>📈</span>
                <span>🗄</span>
              </div>
            </div>
          </div>

          {/* ================= TABLE SECTION ================= */}
          <div className="table-section">
            <div className="data-card">
              <div className="card-title">Booking</div>
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>MODEL</th>
                      {months.map((m) => (
                        <th key={m}>{m}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="total-cell">TOTAL</td>
                      <td colSpan="12"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="data-card">
              <div className="card-title">Sales</div>
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>MODEL</th>
                      {months.map((m) => (
                        <th key={m}>{m}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="total-cell">TOTAL</td>
                      <td colSpan="12"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* ================= SUMMARY CARDS ================= */}
          {/* ================= SUMMARY CARDS ================= */}
          <div className="summary-grid">
            {/* ================= BOOKING ================= */}
            <div className="summary-section">
              <div className="summary-title">Booking</div>

              <div className="summary-card one-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Today</span>
                    <div className="stat-number blue">0</div>
                  </div>
                  <div className="stat">
                    <span>Yesterday</span>
                    <div className="stat-number blue">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>LYMTD</span>
                    <div className="stat-number blue">0</div>
                  </div>
                  <div className="stat">
                    <span>LMTD</span>
                    <div className="stat-number blue">0</div>
                  </div>
                  <div className="stat">
                    <span>MTD</span>
                    <div className="stat-number blue">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>PYTD</span>
                    <div className="stat-number blue">0</div>
                  </div>
                  <div className="stat">
                    <span>YTD</span>
                    <div className="stat-number blue">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>PYMTDC</span>
                    <div className="stat-number blue">0</div>
                  </div>
                  <div className="stat">
                    <span>PMTDC</span>
                    <div className="stat-number blue">0</div>
                  </div>
                  <div className="stat">
                    <span>MTDC</span>
                    <div className="stat-number blue">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Delivery Date Exceed</span>
                    <div className="stat-number blue">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Approved Docket</span>
                    <div className="stat-number blue">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Pending Docket</span>
                    <div className="stat-number blue">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Pending Receipt For Docket</span>
                    <div className="stat-number blue">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Live Booking</span>
                    <div className="stat-number blue">0</div>
                  </div>
                </div>
              </div>
            </div>

            {/* ================= SALES ================= */}
            <div className="summary-section">
              <div className="summary-title">Sales</div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Today</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>Yesterday</span>
                    <div className="stat-number pink">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>LYMTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>LMTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>MTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>PYTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>YTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>S/D PYTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>S/D YTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>S/D MTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>EDTM</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>EDT</span>
                    <div className="stat-number pink">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>EW PYTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>YTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>MTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>AC LYMTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>LMTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>MTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>AA LYMTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>LMTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                  <div className="stat">
                    <span>MTD</span>
                    <div className="stat-number pink">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Pending Insurance</span>
                    <div className="stat-number pink">0</div>
                  </div>
                </div>
              </div>
            </div>

            {/* ================= INVENTORY ================= */}
            <div className="summary-section">
              <div className="summary-title">Inventory</div>

              <div className="summary-card four-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Free</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>Allocated</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>Total</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>BBND</span>
                    <div className="stat-number red">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Pending PDI</span>
                    <div className="stat-number red">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Aging &gt; 3M</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>2M</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>1M</span>
                    <div className="stat-number red">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>P/D PYTD</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>P/D YTD</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>P/D MTD</span>
                    <div className="stat-number red">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>P/C PYTD</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>P/C YTD</span>
                    <div className="stat-number red">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>P/C LYMTD</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>P/C LMTD</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>P/C MTD</span>
                    <div className="stat-number red">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Pending Allocation</span>
                    <div className="stat-number red">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Allocated &gt; 7d</span>
                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>10d</span>

                    <div className="stat-number red">0</div>
                  </div>
                  <div className="stat">
                    <span>13d</span>
                    <div className="stat-number red">0</div>
                  </div>
                </div>
              </div>
            </div>

            {/* ================= FINANCE ================= */}
            <div className="summary-section">
              <div className="summary-title">Finance</div>

              <div className="summary-card three-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>FIH</span>
                    <div className="stat-number green">0</div>
                  </div>
                  <div className="stat">
                    <span>FOH</span>
                    <div className="stat-number green">0</div>
                  </div>
                  <div className="stat">
                    <span>Cash</span>
                    <div className="stat-number green">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Payment OS Customer</span>
                    <div className="stat-number green">0</div>
                  </div>
                  <div className="stat">
                    <span>Payment OS Financer</span>
                    <div className="stat-number green">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Payout OS Customer &gt; 60 days</span>
                    <div className="stat-number green">0</div>
                  </div>
                  <div className="stat">
                    <span>Payout OS Finance &gt; 60 days</span>
                    <div className="stat-number green">0</div>
                  </div>
                </div>
              </div>
              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Payout OS Customer &gt; 60 days</span>
                    <div className="stat-number green">0</div>
                  </div>
                  <div className="stat">
                    <span>Payout OS Finance &gt; 60 days</span>
                    <div className="stat-number green">0</div>
                  </div>
                </div>
              </div>
              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Pending Approval</span>
                    <div className="stat-number green">0</div>
                  </div>
                </div>
              </div>

              <div className="summary-card two-card">
                <div className="summary-content">
                  <div className="stat">
                    <span>Finance Entry Pending</span>
                    <div className="stat-number green">0</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
